import { Pipe, PipeTransform } from '@angular/core';

import { Fai } from '@bytel/bytel-sales';
import { CommercialSeries } from '@bytel/checkout';

@Pipe({
    name: 'playsLabel',
    standalone: true,
})
export class PlaysLabelPipe implements PipeTransform {
    transform(subscription: Fai): string {
        let plays: string = 'Internet';

        if (subscription.play === '3P') {
            plays += ' / TV';
        }

        if (subscription.play === '2P' || subscription.play === '3P') {
            plays += ' / Téléphonie';
        }

        if (subscription.data.commercial_series === CommercialSeries.SMART_TV) {
            plays = 'Internet / TV / Téléphonie + Smart TV';
        }

        return plays;
    }
}
